<template>
    <div :class="[{ active: isActive }, 'item']">
        <div class="icon-wrapper">
            <IconRestore class="icon" />
            <!-- <img :src="icon" :alt="title" />
              -->
        </div>

        <div class="content">
            <p class="title">{{ title }}</p>
            <p class="sub-title">{{ recentMessage }}</p>
        </div>
    </div>
</template>

<script>
import { IconRestore } from '@tabler/icons-vue';

export default {
    props: {
        icon: {
            type: String,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },

        recentMessage: {
            type: String,
            required: true,
        },

        chatId: {
            type: String,
            required: true,
        }
    },

    components: {
        IconRestore
    },

    name: 'ChatItemComponent',

    computed: {
        isActive() {
            return this.$route.params.chatId === this.chatId;
        }
    }
};
</script>

<style scoped>
.item {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: var(--default-border-radius);
    margin-bottom: 8px;
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 12px;
}

.item:hover,
.item.active {
    background-color: var(--color-hover);
}

.icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-top: 8px;
    margin-left: 7px;
}

.title {
    font-size: 14px;
    line-height: 1.4;
}

.sub-title {
    font-size: 12px;
    line-height: 1.2;
}


.title,
.sub-title {
    margin-top: 2px;
}
</style>